
import { Options, Vue } from 'vue-class-component';
import { getError } from "@/utils/helpers";
import RegionListEntry from "@/components/RegionListEntry.vue";
import FieldError from "@/components/forms/FieldError.vue";
import CourseService from "../services/CourseService";
import { Course } from "@/data/course";
import { formatDateWithDayLabel, formatDatetime, formatTime } from "@/utils/helpers";

@Options({
    props: {
        course: {
            type: Object,
            required: true,
        },
        appointmentPreselect: {
            type: [Number, null],
            required: false,
            default: null,
        },
        validationErrors: {
            type: Array,
            required: false,
            default: [],
        },
    },
    components: {
        FieldError,
        RegionListEntry,
    },
    methods: {
        formatDateWithDayLabel,
        formatDatetime,
        formatTime,
    },
    emits: [
        'appointmentSelected'
    ],
    watch: {
        selectedAppointmentId(newVal) {
            this.$emit('appointmentSelected', parseInt(newVal));
        },
    }
})
export default class CoursePreview extends Vue {
    course!: Course
    appointmentPreselect!: number|null
    validationErrors!: Array<any>

    selectedAppointmentId: number|null = null

    get appointments() {
        return this.course?.appointments_upcoming || [];
    }

    mounted() {
        this.selectedAppointmentId = this.appointmentPreselect || this.appointments?.[0].id || null;
    }

    /*onSelect() {
        this.$emit('appointmentSelected', this.selectedAppointmentId);
    }*/
}
